export var Regions = {
  MX: 'ROW',
  TR: 'MENA'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/GeolocationUtils/constants.js
// module id = 3458
// module chunks = 11